import api from '@/api'

export default {
    getDesignData(id: string): Promise<webpartv3.WebpartDesignData[]> {
        return api.get({
            url: `/Webpart/WebpartTemplateParts/api/getlist?id=${id}`,
        })
    },

    setDesignData(
        template: webpartv3.WebpartTemplate
    ) {
        return api.post({
            url: `/Webpart/WebpartTemplateParts/api/setDesign`,
            data: template,
        })
    },
}
